import { TextSorter } from "../../../../library-js/dom-actions/filter-and-sort/sorters/TextSorter";
import { AttributeValue, AttributeValueMatchMode } from "../../../../library-js/dom-tools/AttributeValue";
import { RegExpUtility } from "../../../../library-js/text/RegExpUtility";
import { SortText } from "../../../../library-js/text/SortText";
import { ContextMenu } from "../../../../library-templates/context--menu/ContextMenu";
import { ContextMenuCreator } from "../../../../library-templates/context--menu/ContextMenuCreator";
import { Rokojori } from "../../Rokojori";
import { HeaderMenu } from "../HeaderMenu";
import { LinkContextEntry } from "../LinkContextMenuEntry";


export class Auto_en extends ContextMenuCreator
{
  static value = new AttributeValue( ContextMenuCreator.attribute, "en", AttributeValueMatchMode.STARTS_WITH );
  
  get value(){ return Auto_en.value }
  
  create( e:Element ):ContextMenu
  {
    let entries:LinkContextEntry[] = [];

    let value = Auto_en.value.attribute.from( e );
    let matcher = value.endsWith( "?" ) ? new RegExp( value.substring( 0, value.length - 1 ) ) : RegExpUtility.createMatcher( value );    

    console.log( "MATCHER:", matcher );

    let pages = Rokojori.$.pageHandler.getFilteredPages( matcher );



    pages.forEach(
      p =>
      {
        let link = p.replace( /\/index\.php/, "" );
        link   = link.replace( /\.php/, "" );
        link = "::/" + link;

        let entry = new LinkContextEntry();

        let label = RegExpUtility.fileNameOrLastPath( link ).replace( /\-/g, " " );

        entry.link  = link;
        entry.label = label;

        entries.push( entry );

        console.log( "Creating link:", label, link );
      }
    );

    SortText.sort( entries, e => e.label, true );

    return HeaderMenu.create( "Git", entries );
  }
}